module.exports = __webpack_public_path__ + "dd843f55303e17b31d1c710b311bfa0c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/down-27.png
// module id = 3118
// module chunks = 0